<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 md6>
      <v-flex xs12>
        <v-spacer class="my-2"></v-spacer>
        <h2>{{ $vuetify.t('$vuetify.authentication.password_change') }}</h2>

        <v-spacer class="my-4"></v-spacer>

<!--        <div class="text-xs-center">
          <h4>{{ $vuetify.t('$vuetify.authentication.password_bigger_than10') }}</h4>
          <h4>{{ $vuetify.t('$vuetify.authentication.password_lower_case') }}</h4>
          <h4>{{ $vuetify.t('$vuetify.authentication.password_upper_case') }}</h4>
          <h4>{{ $vuetify.t('$vuetify.authentication.password_one_number') }}</h4>
          <h4>{{ $vuetify.t('$vuetify.authentication.password_special_char') }}</h4>
        </div>-->
      </v-flex>

      <v-spacer class="my-4"></v-spacer>

      <!-- Event Handling - Event Modifiers
      It is a very common need to call event.preventDefault(),
      therefore Vue provides event modifiers for v-on. Recall that modifiers are directive postfixes denoted by a dot. -->
      <v-form v-on:submit.prevent="submit" ref="form" v-model="valid" lazy-validation>
        <v-text-field
            class="password"
            prepend-icon="fal fa-key"
            :append-icon="e1 ? 'fal fa-eye' : 'fal fa-eye-slash'"
            @click:append="() => (e1 = !e1)"
            name="password"
            v-bind:label="$vuetify.t('$vuetify.authentication.password_old')"
            v-model="password"
            :type="e1 ? 'password' : 'text'"
            required
            :counter=false
        ></v-text-field>
        <v-text-field
            class="password"
            prepend-icon="fal fa-key"
            :append-icon="e1 ? 'fal fa-eye' : 'fal fa-eye-slash'"
            @click:append="() => (e1 = !e1)"
            name="new_password"
            v-bind:label="$vuetify.t('$vuetify.authentication.password_new')"
            v-model="new_password"
            :type="e1 ? 'password' : 'text'"
            :rules="passwordRules"
            required
            :counter=false
        ></v-text-field>


        <v-spacer class="my-2"></v-spacer>
        <v-flex xs12>
          <div class="text-xs-center">
            <v-btn
                flat
                @click="goBack"
            >
              <v-icon left small>fal fa-chevron-left</v-icon>
              {{ $vuetify.t('$vuetify.back') }}
            </v-btn>

            <v-btn
                :disabled="!valid"
                @click="submit"
                color="primary"
                large
            >
              {{ $vuetify.t('$vuetify.next') }}
              <v-icon right small>fal fa-angle-double-right</v-icon>
            </v-btn>

          </div>
        </v-flex>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import {userService} from '../../_services'
import {getErrorMessage, recaptchaHelper} from "../../_helpers";

export default {
  data() {
    //Declaring the Data object for the Vue instance; later, after the instance has been mounted:
    //  some of these properties will be updated
    return {
      username: '',
      password: '',
      new_password: '',
      submitted: false,
      valid: false,
      e1: true
    }
  },
  computed: {
    // Defining the Password field as being mandatory;
    passwordRules: function () {
      let upper_case = /[A-Z]/;
      let lower_case = /[a-z]/;
      let number = /\d/;
      let special_char = /[^A-Za-z0-9]/;

      return [
        v => !!v || this.$vuetify.t('$vuetify.authentication.password_required'),
        v => (v && v.length >= 10) || this.$vuetify.t('$vuetify.authentication.password_bigger_than10'),
        v => upper_case.test(v) || this.$vuetify.t('$vuetify.authentication.password_upper_case'),
        v => lower_case.test(v) || this.$vuetify.t('$vuetify.authentication.password_lower_case'),
        v => number.test(v) || this.$vuetify.t('$vuetify.authentication.password_one_number'),
        v => special_char.test(v) || this.$vuetify.t('$vuetify.authentication.password_special_char'),
      ]
    }
  },
  methods: {
    submit() {
      // 1 - setting the Loading Layer
      this.$store.dispatch("loader/setLoading", true);

      this.$log.debug("Before Set New Password for User = " + this.username);

      // 1 - Defining the information to be sent to the Change Password function
      let obj = {
        "old_password": this.password,
        "new_password": this.new_password
      };

      // 2 - Defining variables with both username and password values
      // In case the change password process succeeds, this info is going to be used to simulate the Log In process
      let password = this.new_password;
      let username = this.username;

      // 3 - Once both the username and the password are defined,
      //  it is possible to use the authentication module: the login action is called;
      //  this login action uses the userService's function login which uses the Axios library to fetch data in a async mode (using promises)
      //  to get the API token which will enable the user to be recognized by a match between the user and the received Token
      const {dispatch} = this.$store;

      recaptchaHelper('setNewPassword', this).then((token) => {
            obj.recaptcha_token = token;
            // eslint-disable-next-line
            userService.setNewPassword(obj).then(result => {

                  this.$store.dispatch("alert/success", this.$vuetify.t('$vuetify.authentication.password_change_success'));
                  // 4 - Authenticating the User with the new password
                  if (username && password) {
                    recaptchaHelper('login', this).then((token) => {
                          dispatch('authentication/login', {username, password, token});
                          // 4 - removing the Loading Layer
                          this.$store.dispatch("loader/setLoading", false);
                        },
                        // eslint-disable-next-line
                        error => {
                          this.$log.warn("Login User | Recaptcha Error");
                          this.$store.dispatch("loader/setLoading", false);
                          this.$store.dispatch("alert/error", this.$vuetify.t('$vuetify.generic_error'));
                        });
                  }
                  this.$router.push({name: "home"});
                },
                error => {
                  getErrorMessage(error, 'Set New Password', this);
                });
          },
          error => {
            getErrorMessage(error, 'Set New Password Recaptcha', this);
          });
    },
    goBack() {
      this.$router.push({name: "user"});
    }
  },
  mounted() {
    // Called after the instance has been mounted:
    //  1 - getting from the store the username
    //      which was set on the authentication module by the setLoginUsername mutation
    this.username = this.$store.state.authentication.user.username;
  }
}
</script>

<style scoped>

</style>